import { render, staticRenderFns } from "./MaskImage.vue?vue&type=template&id=5cfe9637&scoped=true&"
import script from "./MaskImage.vue?vue&type=script&lang=js&"
export * from "./MaskImage.vue?vue&type=script&lang=js&"
import style0 from "./MaskImage.vue?vue&type=style&index=0&id=5cfe9637&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfe9637",
  null
  
)

export default component.exports